import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const DropdownMoreIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM3.2818 4.7818C3.10607 4.95754 3.10607 5.24246 3.2818 5.4182L5.6818 7.8182C5.85754 7.99393 6.14246 7.99393 6.3182 7.8182L8.7182 5.4182C8.89393 5.24246 8.89393 4.95754 8.7182 4.7818C8.54246 4.60607 8.25754 4.60607 8.0818 4.7818L6 6.8636L3.9182 4.7818C3.74246 4.60607 3.45754 4.60607 3.2818 4.7818Z"
        fill={getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default DropdownMoreIcon;
